export const aboutData = {
  brandStory: {
    title: "关于 hlw",
    subtitle: "以技术驱动创新，用服务创造价值",
    content: `hlw 成立于 2020 年，总部位于北京中关村科技园。自创立以来，hlw 始终秉持「让技术更简单」的使命，致力于为企业提供高效、安全、易用的数字化解决方案。

经过多年的技术积累和市场实践，hlw 已从最初的单一产品发展为覆盖部署、分析、安全、协作等全场景的一站式技术平台。我们服务了超过 10,000 家企业客户，涵盖电商零售、在线教育、医疗健康、金融服务等多个行业。

hlw 的核心团队来自国内外顶尖互联网企业和科研机构，拥有深厚的技术底蕴和丰富的行业经验。我们坚持自主研发，在容器化部署、智能分析、数据安全等领域拥有多项核心技术专利。`,
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20technology%20company%20office%20interior%20with%20warm%20natural%20light%2C%20clean%20white%20and%20beige%20design%2C%20collaborative%20workspace%2C%20professional%20tech%20atmosphere%2C%20soft%20atmospheric%20lighting&width=1200&height=600&seq=about-brand&orientation=landscape",
  },
  milestones: [
    { year: "2020", event: "hlw 公司正式成立，推出首个产品原型" },
    { year: "2021", event: "完成 A 轮融资，服务客户突破 500 家" },
    { year: "2022", event: "通过 ISO 27001 安全认证，发布智能分析引擎" },
    { year: "2023", event: "客户数量突破 5,000 家，获评年度最佳企业服务品牌" },
    { year: "2024", event: "完成 B 轮融资，服务客户突破 10,000 家" },
    { year: "2025", event: "发布 AI 驱动的第三代平台，市场份额行业前三" },
    { year: "2026", event: "持续创新，开启全球化战略布局" },
  ],
  values: [
    { icon: "ri-lightbulb-line", title: "创新驱动", description: "持续投入研发，保持技术领先" },
    { icon: "ri-user-heart-line", title: "客户至上", description: "以客户成功为衡量标准" },
    { icon: "ri-shield-star-line", title: "安全可靠", description: "把数据安全放在首位" },
    { icon: "ri-team-line", title: "协作共赢", description: "与客户和伙伴共同成长" },
  ],
  reputation: {
    title: "荣誉与资质",
    items: [
      { icon: "ri-award-line", name: "ISO 27001 信息安全管理体系认证", year: "2022" },
      { icon: "ri-award-line", name: "SOC 2 Type II 安全审计认证", year: "2023" },
      { icon: "ri-medal-line", name: "年度最佳企业服务品牌", year: "2023" },
      { icon: "ri-medal-line", name: "中国数字化转型优秀解决方案奖", year: "2024" },
      { icon: "ri-star-line", name: "信创优秀产品奖", year: "2025" },
      { icon: "ri-star-line", name: "年度最具创新力技术平台", year: "2025" },
    ],
  },
  contact: {
    title: "联系我们",
    subtitle: "有任何问题或合作意向，欢迎随时与我们联系",
    email: "contact@hlw.com",
    phone: "400-888-9999",
    address: "北京市海淀区中关村科技园创新大厦18层",
    workingHours: "周一至周五 9:00 - 18:00",
  },
  faqs: [
    {
      q: "hlw 平台适合什么规模的企业使用？",
      a: "hlw 平台适用于各种规模的企业，从独立开发者到大型企业都能找到适合自己的解决方案。我们提供灵活的按需付费模式，您可以根据实际需求选择合适的方案。",
    },
    {
      q: "如何开始使用 hlw 平台？",
      a: "您只需在 hlw 官网注册账号，即可获得 14 天全功能免费试用。注册后会有专属客户经理与您联系，帮助您快速上手。",
    },
    {
      q: "hlw 平台的数据安全如何保障？",
      a: "hlw 已通过 ISO 27001 和 SOC 2 Type II 认证，采用 AES-256 加密存储、TLS 1.3 传输加密等多层安全防护措施，确保您的数据安全。",
    },
    {
      q: "hlw 支持哪些部署方式？",
      a: "hlw 支持公有云、私有云和混合云部署方式。您可以根据企业的安全合规要求选择最合适的部署方案。",
    },
    {
      q: "hlw 是否提供技术支持服务？",
      a: "是的，hlw 提供 7×24 小时全天候技术支持服务，平均响应时间不超过 5 分钟。企业版客户还享有专属客户成功经理的一对一服务。",
    },
  ],
};